import { render, staticRenderFns } from "./ApiConfig.vue?vue&type=template&id=3876d0dc&lang=pug"
import script from "./ApiConfig.vue?vue&type=script&lang=js"
export * from "./ApiConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports